// Pure helpers for "Bring their existing work" (kept apart from the components so they are easy to test).

export function toggleKey(excluded, key) {
  const next = new Set(excluded)
  if (next.has(key)) next.delete(key)
  else next.add(key)
  return next
}

export function selectedRows(plan, excluded, included = new Set()) {
  const extra = (plan?.needs_decision || []).filter((n) => n.can_include && included.has(n.key))
  return [...(plan?.rows || []).filter((r) => !excluded.has(r.key)), ...extra]
}

export function canApplyWorkMove(plan, excluded, busy = false, included = new Set()) {
  return !busy && selectedRows(plan, excluded, included).length > 0
}

// Anything to show at all (something to move, or something the admin should know was left out).
export function hasWork(plan) {
  return Boolean(plan) && ((plan.rows || []).length + (plan.blocked || []).length + (plan.needs_decision || []).length) > 0
}

function plural(n, one, many) {
  return `${n} ${n === 1 ? one : many}`
}

// "3 requests and 1 template will move to nl01" (counts follow the exclusions).
export function workMoveSummary(plan, excluded, opcoCode, included = new Set()) {
  const rows = selectedRows(plan, excluded, included)
  const requests = rows.filter((r) => r.entity_type === 'request').length
  const templates = rows.filter((r) => r.entity_type === 'template').length
  if (requests + templates === 0) return 'Nothing to move.'
  const parts = []
  if (requests) parts.push(plural(requests, 'request', 'requests'))
  if (templates) parts.push(plural(templates, 'template', 'templates'))
  return `${parts.join(' and ')} will move to ${opcoCode}`
}

const ITEM_RESULT = {
  moved: 'moved',
  skipped_changed: 'skipped (changed)',
  failed: 'failed',
}

export function itemResultLabel(result) {
  return ITEM_RESULT[result] || result || ''
}

export function itemUndoLabel(undoResult) {
  if (undoResult === 'reverted') return 'put back'
  if (undoResult === 'skipped_changed') return 'changed since, kept'
  return undoResult || ''
}
